import withTranslations from 'support/hoc/withTranslations'
import { Select as BaseInput } from '@morningtrain/react-fields-advanced-select'

function Select (props) {
  const {
    className
  } = props

  const classNames = [
    'custom-select',
    className
  ]
  return (
    <BaseInput
      {...props}
      className={classNames.join(' ')}
      styles={{ menu: (provided) => ({ ...provided, zIndex: 1000 }) }}
    />
  )
}

export default withTranslations(Select)
